import { Box, Link, Stack, styled, type Theme } from "@schaeffler-commerce/design-system";

export const FooterSection = styled(Box)(({ theme }) => ({
  width: "100%",
  [theme.breakpoints.up("tablet")]: {
    borderTop: `1px solid ${theme.palette.divider}`,
  },
}));

export const responsivePadding = (theme: Theme) => ({
  padding: theme.spacing(4, 2),
  [theme.breakpoints.up("tablet")]: {
    padding: theme.spacing(4, 3),
  },
  [theme.breakpoints.up("desktop-s")]: {
    padding: theme.spacing(4, 2),
  },
  [theme.breakpoints.up("desktop-m")]: {
    padding: theme.spacing(4, 3),
  },
  [theme.breakpoints.up("desktop-l")]: {
    padding: theme.spacing(4, 8),
  },
});

export const FooterHeader = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column-reverse",
  justifyContent: "space-between",
  gap: theme.spacing(3),
  ...responsivePadding(theme),
  [theme.breakpoints.up("desktop-s")]: {
    flexDirection: "row",
    gap: 0,
    padding: theme.spacing(4, 0),
  },
  [theme.breakpoints.up("desktop-m")]: {
    padding: theme.spacing(4, 0),
  },
  [theme.breakpoints.up("desktop-l")]: {
    padding: theme.spacing(4, 0),
  },
}));

export const FooterNavigation = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: 0,
  width: "100%",
  padding: 0,
  [theme.breakpoints.up("tablet")]: {
    gap: theme.spacing(5, 3),
    gridTemplateColumns: "repeat(2, 1fr)",
    padding: theme.spacing(4, 3),
  },
  [theme.breakpoints.up("desktop-s")]: {
    gap: 0,
    gridTemplateColumns: "repeat(4, 1fr)",
    padding: theme.spacing(4, 0),
  },
  [theme.breakpoints.up("desktop-m")]: {
    padding: theme.spacing(4, 0),
  },
  [theme.breakpoints.up("desktop-l")]: {
    padding: theme.spacing(4, 0),
  },
}));

export const LinksColumn = styled("ul")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: 0,
  marginBottom: 0,
  listStyle: "none",
  "& > *:first-of-type": {
    marginTop: 0,
  },
  "& > * + *": {
    marginTop: theme.spacing(2),
  },
}));

export const FooterTopLinkItem = styled("ul")(({ theme }) => ({
  listStyle: "none",
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(2, 3),
  [theme.breakpoints.up("tablet")]: {
    gap: theme.spacing(5),
  },
  alignSelf: "stretch",
  flexWrap: "wrap",
  padding: 0,
  margin: 0,
}));

export const FooterBottom = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "isMobile",
})<{ isMobile: boolean }>(({ theme, isMobile }) => ({
  alignItems: "center",
  flexDirection: isMobile ? "column-reverse" : "row",
  justifyContent: "space-between",
  gap: isMobile ? theme.spacing(3) : undefined,
  padding: theme.spacing(2),
  marginBottom: theme.spacing(7),
  [theme.breakpoints.up("tablet")]: {
    marginBottom: 0,
    padding: theme.spacing(2, 3),
  },
  [theme.breakpoints.up("desktop-s")]: {
    padding: theme.spacing(2, 0),
  },
  [theme.breakpoints.up("desktop-m")]: {
    padding: theme.spacing(2, 0),
  },
  [theme.breakpoints.up("desktop-l")]: {
    padding: theme.spacing(2, 0),
  },
}));

export const LogoWrapper = styled(Box)(({ theme }) => ({
  textAlign: "right",
  [theme.breakpoints.up("desktop-s")]: {
    textAlign: "initial",
  },
}));

export const FooterLink = styled(Link)(({ theme }) => ({
  color: theme.palette.textSecondary.main,
  "&:hover": {
    color: theme.palette.textPrimary.main,
  },
}));
